import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "inner-modal inner-modal--af" }
const _hoisted_2 = { class: "inner-modal--header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, "Advanced Filters", -1 /* HOISTED */)
const _hoisted_4 = { class: "inner-modal--form" }
const _hoisted_5 = {
  key: 0,
  class: "row"
}
const _hoisted_6 = {
  key: 1,
  class: "inner-modal--af--loading text-center"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "mt-3" }, "Loading filters..", -1 /* HOISTED */)
const _hoisted_8 = {
  key: 0,
  class: "inner-modal--done"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Cta = _resolveComponent("Cta")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_font_awesome_icon, {
        icon: ['fasl', 'fa-filter'],
        class: "inner-modal--header--icon"
      }),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      (!$setup.filterProps.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filterProps.filterOptions, (filter, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "col-sm-12 col-md-4 col-lg-4 p-3"
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(filter.displayType), _mergeProps(filter, {
                  isSmallLabel: false,
                  showNumResults: true,
                  key: filter.slug,
                  onFilterChange: $setup.handleUpdateFilters
                }), null, 16 /* FULL_PROPS */, ["onFilterChange"]))
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fad', 'spinner-third'],
              spin: ""
            }),
            _hoisted_7
          ]))
    ]),
    (!$setup.filterProps.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_Cta, {
            type: "outline",
            size: "lg",
            label: "Done",
            onOnClick: $setup.closeModal
          }, null, 8 /* PROPS */, ["onOnClick"])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args))),
      class: "inner-modal__close"
    }, "×")
  ]))
}